<template>
    <div class="bg-gradient-loch">
        <a class="skip-main" href="#main">Skip to main content</a>
        <div class="home my-4 px-4 container">
            <div class="row mb-4">
                <div id="main" role="main" class="col-12">
                    <form ref="form" label-position="left" class="userform">
                        <div class="card shadow mx-auto mt-4 max-width-4 bg-light px-lg-5 px-md-0 px-lg-5">
                            <div class="card-body px-lg-5 text-left">
                                <h2 class="mb-4 mt-3">Create Account</h2>
                                <form-errors :errors="errors" aria-invalid='true'></form-errors>
                                <app-error :error="defaultError" aria-invalid='true'></app-error>
                                <app-success :success="defaultSuccess" aria-invalid='true'></app-success>
                                <user-form :user-form="registerForm" :show-password="true"></user-form>
                                <div class="text-center mt-4">
                                    <p>By choosing "Register" you agree to the <a v-if="name == 'sestran'" href="https://support.gosestran.co.uk/portal/en/kb/articles/gosestran-terms-conditions"> Terms &amp; Conditions</a> <router-link v-if="name != 'sestran'" to="/terms-and-conditions"> Terms &amp; Conditions</router-link> of {{ name == 'sestran' ? 'GoSEStran' : 'National Park' }} Journey Planner</p>
                                </div>
                                <b-button class="full-green-btn mt-3" @click="register()" :disabled="formLock">
                                    <span v-if="!formLock">Register <svg-icon v-if="name != 'sestran'" class="arrow-right-find" name="forward"></svg-icon></span>
                                    <b-spinner v-if="formLock" type="grow" label="Spinning" style="width: 24px; height: 24px;" class="app-spinner-white"></b-spinner>
                                </b-button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mutationsMapping from '@/store/mutations-mapping'
import {
    mapState,
    mapMutations,
    mapActions,
} from 'vuex'
import moment from 'moment'
import FormErrors from '@/components/FormErrors.vue'
import AppError from '@/components/AppError.vue'
import AppSuccess from '@/components/AppSuccess.vue'
import UserForm from '@/components/UserForm.vue'

const whitelabel = require('../../../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {

    name: 'Home',
    components: {
        UserForm,
        FormErrors,
        AppError,
        AppSuccess,
    },
    data() {
        return {
            name: whitelabel.brand,
            formLock: false,
            registerForm: {
                title: null,
                first_name: '',
                last_name: '',
                email: '',
                phone_number: '',
                password: '',
                password_confirmation: '',
                dob: '',
                has_concessionary_pass: false,
                has_young_scot_card: false,
                has_new_young_scot_card: false,
                has_car_access: false,
                creation_origin: 'HOME_PAGE',
                railcard: '',
            },
        }
    },
    computed: {
        ...mapState([
            'errors',
            'defaultError',
            'defaultSuccess',
        ]),
    },
    methods: {
        ...mapMutations(mutationsMapping),
        ...mapActions([
            'registerUser',
        ]),

        onFocus(field) {
            this.setError({
                field,
                error: false,
            })
        },
        prepareInput() {
            const registerForm = { ...this.registerForm }
            registerForm.dob = this.formatDate(this.registerForm.dob)
            if (registerForm.dob) {
                registerForm.dob = this.formatDate(this.registerForm.dob)
            } else {
                delete registerForm.dob
            }
            return registerForm
        },
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD')
        },

        register() {
            this.setDefaultError(false)
            this.setDefaultSuccess(false)
            this.registerUser({
                params: this.prepareInput(),
                router: this.$router,
            })
        },

    },
    mounted() {
        this.setDefaultError(false)
        this.setDefaultSuccess(false)
        this.clearErrors()
    },
}
</script>
